var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartTypeSingleLineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 10,
    viewBox: "0 0 20 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 2.45895L12.8333 6.64702L8.64444 4.21053L0 9.26316V6.78175L8.64444 1.74035L12.8333 4.21053L20 0V2.45895Z",
    fill: "var(--report-graph-bar-stack-color)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartTypeSingleLineIcon);
export default __webpack_public_path__ + "static/media/chart-type-single-line-icon.b4ecef9daa6e78332bb7ea5ffaa4e49e.svg";
export { ForwardRef as ReactComponent };